import { API } from '@/api';
import axios from 'axios';

const state = {
};

const getters = {
};

const actions = {
  async addSerie({ commit, State }, {admin, condo, serie}) {
    const response = await API.post(`${admin.id}/${condo.id}/series/add/`, serie);
    return response.data;
  },
  async getSeriesList( { commit, State }, {admin, condo}) {
    const response = await API.get(`${admin.id}/${condo.id}/series/list/`);
    return response.data;
  },
};

const mutations = {
};

export default {
  actions,
  getters,
  mutations,
  state,
};
